import React from 'react';
import * as S from 'styles';
import * as C from 'components';
import * as D from 'data';
import styled from 'styled-components';
import { Button } from 'components/button';

export function ChallengeBox({ item }) {
  return (
    <CallengeWrap>
      <C.Badge
        className="badge"
        $bgColor={
          D.areaList.find((area) => area.name === item.host)?.color ||
          D.areaList.find((area) => area.name === '기타').color
        }
      >
        {item.host}
      </C.Badge>
      <ImgBox>
        <C.Img src={item.img} $height={130} $objectFit="cover" />
        <InfoBox>
          <C.Icon name="ChallengeWalk" />
          <S.Text $type="label12" $color="mint">
            {item.join.toLocaleString()}명 참여중
          </S.Text>
        </InfoBox>
      </ImgBox>
      <S.Div $padding="4px 2px">
        <S.Text $type="label12" $color="gray500">
          {item.startDate}~{item.endDate}
        </S.Text>
        <S.Text $type="b" $color="gray800">
          {item.title}
        </S.Text>
      </S.Div>
      <Button type={item.state === 1 && 'sub'} $size="m">
        {item.state === 0 ? '참여하기' : '참여중'}
      </Button>
    </CallengeWrap>
  );
}

const CallengeWrap = styled(S.Div)`
  padding: 4px;
  position: relative;
  border-radius: 4px;
  background-color: ${S.theme.colors.fill02};

  .badge {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  }
`;

const ImgBox = styled(S.Div)`
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  border: 1px solid ${S.theme.colors.gray200};
  min-height: 120px;
`;

const InfoBox = styled(S.RowDiv)`
  ${S.rowCenter}
  padding: 2px 0;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.92);
`;
